import React from 'react'

interface ControlCenterPlaceholderProps {
  title: string
  description: string
  icon: React.ReactNode
  ticketRef?: string
}

export function ControlCenterPlaceholder({
  title,
  description,
  icon,
  ticketRef,
}: ControlCenterPlaceholderProps): React.ReactElement {
  return (
    <div className="flex flex-col items-center justify-center py-20">
      <div className="w-16 h-16 bg-slate-800 rounded-2xl flex items-center justify-center mb-6 border border-slate-700">
        {icon}
      </div>
      <h2 className="text-xl font-bold text-white mb-2">{title}</h2>
      <p className="text-slate-400 text-center max-w-md mb-4">{description}</p>
      {ticketRef && (
        <span className="text-xs text-slate-600 bg-slate-800 px-3 py-1 rounded-full border border-slate-700">
          {ticketRef}
        </span>
      )}
    </div>
  )
}
